<template>
<div class="flex w-full vx-row no-gutter justify-center">
  <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    <vx-card class="study-card"> 
       <vs-list>
        <vs-list-header title="발음을 통해 영어 단어의 음가와 의미를 파악합니다." icon-pack="feather" icon="icon-info"></vs-list-header>
        <vs-list-item class="msg-grp-container">
          <vs-chip color="warning mr-0">{{ contentIndex + 1 }} / {{contentsLen}}</vs-chip>
        </vs-list-item>
      </vs-list>
      <div class="ww-jumbotron-content-sentence lg:p-4 md:p-3 sm:p-2 p-4 rounded-lg mb-3 text-center">
        <p class="sentence text-primary">{{ content.sentence }}</p>
      </div>
      <div class="ww-jumbotron-content-translation lg:p-4 md:p-3 sm:p-2 p-4 rounded-lg  text-center" >
        <p class="sentence text-success">{{ content.translation}}</p>
      </div>
      
      <div>
        <div class="text-center mt-3">
          <vue-record-audio v-show="!recordingFinished" :mode="recordMode.audio" @result="onResult" />
          <div v-show="recordingFinished" class="text-center mt-3">
            <audio ref="userAudioPlayer" :src="recording" controls v-on:ended="userAudioFinish"  />
          </div>
        </div>
      </div>
      <vs-alert  v-show="audioFinished" class="mt-3 text-center" >
          위 버튼을 누른 상태에서 녹음을 진행합니다. 녹음이 끝나면 버튼을 놓으세요.
      </vs-alert>
      <div class="text-center">
        <audio ref="audioPlayer" 
            controls
            hidden
            v-on:ended="audioFinish" 
            controlsList="nodownload">Your browser does not support the <code>audio</code> element.
        </audio>
      </div>

    </vx-card>
    <top-button-bar @onReload="onReload" @onNext="onNext" @onFinish="onFinish" @onHint="onHint" ></top-button-bar>
  </div>  
</div>
</template>

<script>
import StudyMenuMixin from './StudyMenuMixin'
import TopButtonBar      from './TopButtonBar.vue'

export default {
  mixins: [StudyMenuMixin],
  components: {
    TopButtonBar
  },
  data () {
    return {
      contentList: [],
      contentsLen: 0,
      contentIndex: 0,
      recordMode: {
        audio: 'hold',
        video: 'press'
      },
      recording: '',
      audioFinished: false,
      recordingFinished: false
    }
  },
  computed: {
    content () {
      return this.contentList[this.contentIndex]
    },
    audioPlayer () {
      return this.$refs.audioPlayer
    },
    userAudioPlayer () {
      return this.$refs.userAudioPlayer
    }
  },
  methods: {
    onResult (data) {
      this.recording = window.URL.createObjectURL(data)
      this.recordingFinished = true
      
      setTimeout(function () {
        this.userAudioPlayer.play()
      }.bind(this), 1000)
      
    },
    onReload () {
      this.contentIndex = 0
      this.audioFinished = false
      this.recordingFinished = false
      this.startAlert()
    },
    onStart () {
      this.audioPlayer.src = this.content.audio
      this.audioPlayer.play()
    },
    audioFinish () {
      this.audioFinished = true
    },
    userAudioFinish () {

      setTimeout(function () {

        if (this.contentIndex >= this.contentsLen - 1) {
          this.onComplete()
        } else {
          this.contentIndex++
          this.audioFinished = false
          this.recordingFinished = false
          this.onStart()
        }
      }.bind(this), 1000)
    },
    startAlert () {
      this.startStudyDlg('발음을 통해 영어 단어의 음가와 의미를 파악합니다.')
    },
    acceptAlert () {
      this.onStart()
    }
  },
  created () {

    const contentJson = JSON.parse(this.sourceContent.contentBody)
    for (let i = 0; i < contentJson.sentence.length; i++) {
      const content = {
        sentence: contentJson.sentence[i],
        translation: contentJson.translation[i],
        audio: this.$buildAudioPath(this.sourceContent.contentCode, i + 1)
      } 
      this.contentList.push(content)
    }
    
    this.contentsLen = this.contentList.length
    this.startAlert()

  },
  mounted () {
  }
}

</script>

<style scoped>
.ww-jumbotron-content-sentence {
    border:1px solid #7367F0;
}
.ww-jumbotron-content-translation {
    border:1px solid #28C76F;
}
.tc-ww-input {
    height: 50px;
    width: 200px;
    font-size: 30px;
    text-align: center;
    letter-spacing:10px;
} 
</style>